"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeClient = void 0;
const query_1 = require("../query");
class EdgeClient {
    constructor(params) {
        this.cookieJar = {};
        this.apiKey = params.apiKey;
        const baseUrlList = [...new Set([params.baseUrl, ...(params.failbackUrls ?? [])])];
        let currentUrl = 0;
        this.baseUrls = {
            get length() {
                return baseUrlList.length;
            },
            reset() {
                currentUrl = 0;
                return baseUrlList[currentUrl];
            },
            next: () => {
                currentUrl = (currentUrl + 1) % baseUrlList.length;
                return { value: baseUrlList[currentUrl], done: false };
            },
        };
        this._baseUrl = baseUrlList[0];
        this._baseUrlLastSet = Date.now();
    }
    async health(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health`,
            optionsOverrides,
        });
        return result.body;
    }
    async listStatuses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/status`,
            optionsOverrides,
        });
        return result.body;
    }
    async createApiToken(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/api-token/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listApiTokens(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/api-token/`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteApiToken(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/api-token/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async setApiTokenEnsureOperatorToken(optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/api-token/ensure-operator-token`,
            optionsOverrides,
        });
        return result.body;
    }
    async getIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateIpMapping(region, privateIp, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listIpMappings(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/ip-mapping/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createIpMapping(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/ip-mapping/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteIpMapping(region, privateIp, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/ip-mapping/${region}/${privateIp}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createEcho(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/echo`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getTls(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tls`,
            optionsOverrides,
        });
        return result.body;
    }
    async setTls(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/tls`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async syncTls(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/tls/sync`,
            optionsOverrides,
        });
        return result.body;
    }
    async getGlobalsettings(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/globalsettings`,
            optionsOverrides,
        });
        return result.body;
    }
    async setGlobalsettings(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/globalsettings`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGlobalsettings(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/globalsettings`,
            optionsOverrides,
        });
        return result.body;
    }
    async createBackup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/backup`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegion(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listRegions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/region/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createRegion(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/region/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteRegion(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/region/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getImage(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/image/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createImage(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/image/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteImage(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/image/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getMedia(id, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/media/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceInternalStatuses(secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/internal-statuses`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async listAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceRegisteredTypes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/registered-types`,
            optionsOverrides,
        });
        return result.body;
    }
    async clearApplianceConfig(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/config/clear`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceNdiSources(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ndi-sources`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliance(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async upgradeAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/upgrade`,
            optionsOverrides,
        });
        return result.body;
    }
    async recreateApplianceTunnels(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/tunnels/recreate`,
            optionsOverrides,
        });
        return result.body;
    }
    async restartAppliance(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/restart`,
            optionsOverrides,
        });
        return result.body;
    }
    async commandAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/command`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliancePorts(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/ports`,
            optionsOverrides,
        });
        return result.body;
    }
    async setAppliancePorts(id, body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/appliance/${id}/ports`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateAppliance(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAppliance(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyApplianceGet(id, path, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyAppliancePost(id, path, body, optionsOverrides = { json: false }) {
        const result = await this._post({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyAppliancePut(id, path, body, optionsOverrides = { json: false }) {
        const result = await this._put({
            resource: `/api/appliance/${id}/proxy${path}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async proxyApplianceDelete(id, path, optionsOverrides = { json: false }) {
        const result = await this._delete({
            resource: `/api/appliance/${id}/proxy${path}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceInputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/inputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listApplianceOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listAppliancePcaps(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/pcap/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAppliancePcap(applianceId, pcapId, optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteAppliancePcap(applianceId, pcapId, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/appliance/${applianceId}/pcap/${pcapId}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGeoAppliances(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/geoAppliance/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listTunnels(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listTunnelOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/tunnel/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createApplianceAllocation(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance-allocation`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getSanity(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/sanity`,
            optionsOverrides,
        });
        return result.body;
    }
    async getTestSleep(s, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/test/sleep/${s}`,
            optionsOverrides,
        });
        return result.body;
    }
    async setStatefulsetScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/scale`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getStatefulsetScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/scale`,
            optionsOverrides,
        });
        return result.body;
    }
    async setStatefulsetTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getStatefulsetTag(name, container, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/statefulset/${name}/${container}/tag`,
            optionsOverrides,
        });
        return result.body;
    }
    async setDeploymentTag(name, container, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/${container}/tag`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDeploymentScale(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}/scale`,
            optionsOverrides,
        });
        return result.body;
    }
    async setDeploymentScale(name, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/deployment/${name}/scale`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDeployment(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/deployment/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPodStatus(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/status`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPodLogs(name, containerName, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}/logs/${containerName}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deletePod(name, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getPod(name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listPods(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/pod/`,
            optionsOverrides,
        });
        return result.body;
    }
    async listKubernetesNodes(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/node/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listIngresses(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/ingress/`,
            optionsOverrides,
        });
        return result.body;
    }
    async listResourceUsages(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/resourceUsage/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getKubernetesNode(regionId, name, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateKubernetesNode(regionId, name, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/k8s/region/${regionId}/node/${name}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listRegionKubernetesNodes(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${id}/node/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegionVideoScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setRegionVideoScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/videoscale/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getRegionThumbScale(regionId, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setRegionThumbScale(regionId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/k8s/region/${regionId}/thumbscale/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listAlarms(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async setAlarm(alarmId, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/alarm/${alarmId}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async backupMonitorAlarms(body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/alarm/backup-monitor/`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async getPort(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listPorts(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/port/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async login(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/login/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async impersonate(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/impersonate/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async unimpersonate(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/unimpersonate`,
            optionsOverrides,
        });
        return result.body;
    }
    async getCurrentUser(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/current-user`,
            optionsOverrides,
        });
        return result.body;
    }
    async totpCurrentUsers(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        });
        return result.body;
    }
    async setCurrentUserTotpVerify(body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/current-user/totp/verify`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteCurrentUserTotps(optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/current-user/totp`,
            optionsOverrides,
        });
        return result.body;
    }
    async logout(optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/logout/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getCheckSuperAuthentication(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/check-super-authentication`,
            optionsOverrides,
        });
        return result.body;
    }
    async getAuthRequest(role, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/auth/request/${role}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listUsers(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getUser(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createUser(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteUser(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/user/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateUser(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/user/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getUserSettings(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/user/${id}/settings`,
            optionsOverrides,
        });
        return result.body;
    }
    async setUserSettings(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/user/${id}/settings`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateGroup(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async createGroup(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/group/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroups(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroup(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGroup(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/group/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroupCoreSecret(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/group/${id}/core-secret`,
            optionsOverrides,
        });
        return result.body;
    }
    async setGroupCoreSecret(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/group/${id}/core-secret`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputServiceOverview(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/service-overview`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getServiceGraphConfig(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service-graph/config`,
            optionsOverrides,
        });
        return result.body;
    }
    async createInput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputStreamGraph(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/stream-graph`,
            optionsOverrides,
        });
        return result.body;
    }
    async listInputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getInput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async updateInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async pcapInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/pcap/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async sendToOutputsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/sendToOutputs`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateRecipientsInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/updateRecipients`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async rerouteInput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/reroute`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async enableInputPreview(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/input/${id}/preview/enable`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteInput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteInputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/input`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async listInputDistributions(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/distribution/`,
            optionsOverrides,
        });
        return result.body;
    }
    async setInputDistributions(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/input/${id}/distribution/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/health/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getInputHlsAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/input/${id}/hls-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async getChannelCheckThumbReadAccess(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/channel/${id}/check-thumb-read-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async setInputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/input/admin-status`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateOutput(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async setOutputInput(id, body, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/api/output/${id}/input`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async createOutput(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/output/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutput(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutputHealth(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/output/${id}/health/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutput(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutputs(regularQueryParams, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/output`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async setOutputAdminStatuses(body, optionsOverrides = {}) {
        const result = await this._patch({
            resource: `/api/output/admin-status`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getDashboardBitrates(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/dashboard/bitrates/`,
            optionsOverrides,
        });
        return result.body;
    }
    async getThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/thumb-routes`,
            optionsOverrides,
        });
        return result.body;
    }
    async region(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/internal/region/${id}/rpc`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async listRawThumbRoutes(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/raw-thumb-routes`,
            optionsOverrides,
        });
        return result.body;
    }
    async getBuildInfo(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/build-info`,
            optionsOverrides,
        });
        return result.body;
    }
    async listRpcSessions(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/rpc-session/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteRpcSession(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/rpc-session/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listAlarmLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/alarm-log/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listAuditLogs(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/audit-log/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientListOutputs(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputs`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientListOutputsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/${id}/outputsNotInList`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createOutputRecipientList(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateOutputRecipientList(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/outputRecipientList/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteOutputRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/outputRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listOutputAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/outputAndRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientListGroups(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groups`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupRecipientListGroupsNotInLists(id, query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupRecipientList/${id}/groupsNotInList`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async createGroupRecipientList(body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/`,
            query,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateGroupRecipientList(id, body, query, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/groupRecipientList/${id}`,
            query,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteGroupRecipientList(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/groupRecipientList/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGroupAndRecipientLists(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/groupAndRecipientList/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getCoreSecret(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret`,
            optionsOverrides,
        });
        return result.body;
    }
    async getBillingReport(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/billing-report`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async getUsageReport(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/usage-report`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getConnectitTokens(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/connectit/tokens`,
            optionsOverrides,
        });
        return result.body;
    }
    async listNetworks(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getNetwork(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/network/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createNetwork(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async updateNetwork(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/network/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async deleteNetwork(id, optionsOverrides = {}) {
        const result = await this._delete({
            resource: `/api/network/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async listServices(query, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/`,
            query,
            optionsOverrides,
        });
        return result.body;
    }
    async getService(id, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/service/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async updateService(id, body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/service/${id}`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getGrafanaDashboardsHome(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/dashboards/home`,
            optionsOverrides,
        });
        return result.body;
    }
    async listGrafanaDashboards(regularQueryParams, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/grafana/api/search`,
            regularQueryParams,
            optionsOverrides,
        });
        return result.body;
    }
    async setGrafanaUserHelpflags(flag, optionsOverrides = {}) {
        const result = await this._put({
            resource: `/grafana/api/user/helpflags/${flag}`,
            optionsOverrides,
        });
        return result.body;
    }
    async createGrafanaApiUserStarsDashboard(id, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/grafana/api/user/stars/dashboard/${id}`,
            optionsOverrides,
        });
        return result.body;
    }
    async getHealthBackendAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-backend-appliance`,
            optionsOverrides,
        });
        return result.body;
    }
    async registerAppliance(body, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/register`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    async getApplianceConfig(id, secret, optionsOverrides = {}) {
        const result = await this._get({
            resource: `/api/appliance/${id}/config`,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceVersionMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/version`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceSrtStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/srt-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async sendApplianceRtmpStatsMessage(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message/rtmp-stats`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async messageAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/message`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async logAppliance(id, body, secret, optionsOverrides = {}) {
        const result = await this._post({
            resource: `/api/appliance/${id}/log`,
            body,
            optionsOverrides: { ...optionsOverrides, headers: { ...optionsOverrides.headers, 'edge-secret': secret } },
        });
        return result.body;
    }
    async getCoreSecretAppliance(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/core-secret-appliance`,
            optionsOverrides,
        });
        return result.body;
    }
    async getThumbWriteAccess(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/internal/auth/thumb-write-access`,
            optionsOverrides,
        });
        return result.body;
    }
    async getHealthStreamMonitor(optionsOverrides = {}) {
        const result = await this._get({
            resource: `/health-stream-monitor`,
            optionsOverrides,
        });
        return result.body;
    }
    async getApplianceSoftware(optionsOverrides = { json: false }) {
        const result = await this._get({
            resource: `/api/appliance/software`,
            optionsOverrides,
        });
        return result.body;
    }
    async applianceSoftware(body, optionsOverrides = { json: false }) {
        const result = await this._post({
            resource: `/api/appliance/software`,
            body,
            optionsOverrides,
        });
        return result.body;
    }
    get baseUrl() {
        if (Date.now() - this._baseUrlLastSet > 60000) {
            this.baseUrl = this.baseUrls.reset();
        }
        return this._baseUrl;
    }
    set baseUrl(url) {
        this._baseUrlLastSet = Date.now();
        this._baseUrl = url;
    }
    async _get(params) {
        return this._call('GET', params);
    }
    async _post(params) {
        return this._call('POST', params);
    }
    async _put(params) {
        return this._call('PUT', params);
    }
    async _delete(params) {
        return this._call('DELETE', params);
    }
    async _patch(params) {
        return this._call('PATCH', params);
    }
    _call(method, params) {
        const queryParams = Object.assign({}, params.regularQueryParams);
        if (params.query) {
            const queryObject = (0, query_1.toQueryParams)(params.query);
            Object.assign(queryParams, queryObject);
        }
        const queryString = Object.entries(queryParams)
            .reduce((acc, [key, value]) => {
            return [
                ...acc,
                value === undefined || value === null
                    ? `${this.encode(key)}=`
                    : `${this.encode(key)}=${this.encode(value)}`,
            ];
        }, [])
            .join('&');
        const url = `${this.baseUrl}${params.resource}?${queryString}`;
        return this.request({
            method,
            url,
            body: params.body,
            optionsOverrides: params.optionsOverrides,
        });
    }
    async request(params, attempt = 1) {
        try {
            return await this._request(params);
        }
        catch (err) {
            if (this.baseUrls.length > attempt) {
                this.baseUrl = this.baseUrls.next().value;
                return this.request(params, attempt + 1);
            }
            throw err;
        }
    }
    /// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
    encode(val) {
        return encodeURIComponent(val)
            .replace(/%3A/gi, ':')
            .replace(/%24/g, '$')
            .replace(/%2C/gi, ',')
            .replace(/%20/g, '+')
            .replace(/%5B/gi, '[')
            .replace(/%5D/gi, ']');
    }
}
exports.EdgeClient = EdgeClient;
//# sourceMappingURL=data:application/json;base64,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